import React, { useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { useMedicalInfoWorkflow } from "../../hooks/useMedicalInfoFlow"
import { useCurrentUser } from "../../../context/user/UserContext"
import { useGetRoutingInfo } from "components/carrot-plans/shared/useQueryRoutingInfo"

export default function ShowMedicalQuestionsDecisionStep(): JSX.Element {
  const { IsAMAB, IsAFAB } = useMedicalInfoWorkflow()
  const { isUsa, sex } = useCurrentUser()
  const { data: routingData } = useGetRoutingInfo()
  const amabAfabMedicalPreference = routingData?.amabAfabMedicalPreference
  const skipMedicalQuestionsForJourneyStage: boolean =
    routingData?.journeyStage === "POSTPARTUM_PARENTING" || routingData?.journeyStage === "PARENTING"

  function showMedicalQuestion(): string {
    if (skipMedicalQuestionsForJourneyStage) {
      return "NO"
    }
    if (isUsa && (IsAMAB || IsAFAB)) {
      if (amabAfabMedicalPreference) {
        return "YES"
      } else {
        return sex === "FEMALE" && IsAMAB ? "NO" : "YES"
      }
    }
    return "NO"
  }

  const { send } = useStateMachine()
  useEffect(() => {
    send(showMedicalQuestion())
  })
  return <></>
}
